import { motion } from 'framer-motion';

interface XPBarProps {
  currentXp: number;
  xpForCurrentLevel: number;
  xpForNextLevel: number;
  progress: number;
  showLabel?: boolean;
  size?: 'sm' | 'md' | 'lg';
}

export function XPBar({
  currentXp,
  xpForCurrentLevel,
  xpForNextLevel,
  progress,
  showLabel = true,
  size = 'md',
}: XPBarProps) {
  const heightClasses = {
    sm: 'h-2',
    md: 'h-3',
    lg: 'h-4',
  };

  const xpInLevel = currentXp - xpForCurrentLevel;
  const xpNeeded = xpForNextLevel - xpForCurrentLevel;

  return (
    <div className="w-full">
      {showLabel && (
        <div className="flex justify-between items-center mb-1">
          <span className="text-xs text-slate-400">XP Progress</span>
          <span className="text-xs font-medium text-slate-300">
            {xpInLevel.toLocaleString()} / {xpNeeded.toLocaleString()} XP
          </span>
        </div>
      )}
      <div
        className={`bg-charcoal-800 rounded-full ${heightClasses[size]} overflow-hidden border border-charcoal-700/50`}
      >
        <motion.div
          initial={{ width: 0 }}
          animate={{ width: `${progress}%` }}
          transition={{ duration: 0.8, ease: 'easeOut' }}
          className="h-full bg-royal-gradient relative"
        >
          {/* Shimmer effect */}
          <motion.div
            className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent"
            animate={{ x: ['-100%', '100%'] }}
            transition={{
              duration: 2,
              repeat: Infinity,
              repeatDelay: 3,
            }}
          />
        </motion.div>
      </div>
    </div>
  );
}

interface SimpleXPBarProps {
  progress: number;
  size?: 'sm' | 'md' | 'lg';
}

export function SimpleXPBar({ progress, size = 'md' }: SimpleXPBarProps) {
  const heightClasses = {
    sm: 'h-1.5',
    md: 'h-2',
    lg: 'h-3',
  };

  return (
    <div
      className={`bg-charcoal-800 rounded-full ${heightClasses[size]} overflow-hidden`}
    >
      <motion.div
        initial={{ width: 0 }}
        animate={{ width: `${progress}%` }}
        transition={{ duration: 0.5, ease: 'easeOut' }}
        className="h-full bg-royal-gradient"
      />
    </div>
  );
}
